export default __webpack_public_path__ + "static/media/Croc6.2182edd1.png";